import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '参数变量',
    type: 'UI_PARAM',
}
